import './Switch.css';

function Switch({ changeCallback, initialValue, id }) {
    return (
        <label className='switch'>
            <input type='checkbox' checked={initialValue} onChange={changeCallback} id={id} />
            <span className='slider round'></span>
        </label>
    );
}

export { Switch };
